import { File } from '@tribeplatform/gql-client/types'

const toDataURL = (url: string) => {
  return fetch(url)
    .then(response => response.blob())
    .then(blob => URL.createObjectURL(blob))
}

export const downloadFile = async (
  document: Document,
  src: string,
  name?: string,
): Promise<void> => {
  try {
    const a = document.createElement('a')
    a.href = await toDataURL(src)
    a.download = name || ''
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  } catch (e) {
    window.open(src, '_blank').focus()
    // eslint-disable-next-line no-console
    console.error('Error while downloading file', e.message)
  }
}

export const PREVIEW_SUPPORTED_EXTENSION = [
  'jpg',
  'jpeg',
  'png',
  'jiff',
  'gif',
  'pdf',
  'svg',
  'mp4',
  'ogg',
  'mp3',
  'wav',
]

export const hasPreview = (attachment: File) => {
  const extension = attachment?.extension?.toLowerCase()
  return PREVIEW_SUPPORTED_EXTENSION.includes(extension)
}
